module.exports = function() {
  return new Worker("/" + "download.worker.6fe54e155f75f29d6e76.js");
};